module.exports = __webpack_public_path__ + "static/img/advantagebg1.895bb367.png";